import styled from '@emotion/styled';
import { IconButton, type IconButtonProps } from '@mui/material';
import stripProps from '@/lib/utils/stripProps';
import { Clear as ClearIcon } from '@mui/icons-material';

type ClearButtonProps = IconButtonProps & {
  visible: boolean;
};

const StyledButton = styled(
  stripProps(IconButton, 'visible'),
)<ClearButtonProps>(({ theme, visible }) => ({
  transform: visible ? 'scale(1)' : 'scale(0)',
  transition: theme.transitions.create('all'),
}));

const ClearButton = (props: ClearButtonProps) => (
  <StyledButton size="large" edge="end" {...props}>
    <ClearIcon />
  </StyledButton>
);

export default ClearButton;
